import React from "react";
import moment from "moment";
import Card from "Card";
import Icon from "Icon";
import DisplayField from "DisplayField";
import barcodeUrl from "./barcodeUrl";

const PrepaidCreditCard = ({ credit }) => (
  <Card>
    <div className="is-flex is-align-items-center mb-3">
      <span className={`tag ${!credit.active ? "is-danger" : "is-success"} mr-2`}>
        <Icon icon={!credit.active ? "times" : "check"} />
      </span>
      <span className="is-size-5 has-text-weight-bold">{credit.code}</span>

      <div className="ml-auto is-flex is-align-items-center">
        <a
          href={barcodeUrl(credit.code)}
          target="_blank"
          rel="noopener noreferrer"
          title="Open barcode in a new tab"
        >
          <img
            src={barcodeUrl(credit.code)}
            alt={`Barcode for ${credit.code}`}
            width="200"
            height="30"
          />
        </a>
        <a
          className="button is-small is-light ml-2"
          href={barcodeUrl(credit.code, { download: true })}
          download={`${credit.code}.png`}
          title="Download barcode"
        >
          <Icon icon="download" />
        </a>
      </div>
    </div>

    <DisplayField label="Initial Balance" value={credit.initialBalance} />
    <DisplayField label="Current Balance" value={credit.currentBalance} />
    {credit.venue && <DisplayField label="Venue" value={credit.venue.name} />}
    <DisplayField
      label="Status"
      value={
        <span className={!credit.active ? "has-text-danger" : "has-text-success"}>
          {!credit.active ? "Inactive" : "Active"}
        </span>
      }
    />
    <DisplayField
      label="Expires At"
      value={credit.expiresAt ? moment(credit.expiresAt).format("MM/DD/YYYY") : "No expiry"}
    />
    <DisplayField
      label="Created At"
      value={credit.createdAt ? moment(credit.createdAt).format("MM/DD/YYYY") : "—"}
    />
  </Card>
);

export default PrepaidCreditCard;
